<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="currentColor"
  >
    >
    <path
      d="M28 26v12q0 .85-.575 1.425Q26.85 40 26 40h-4q-.85 0-1.425-.575Q20 38.85 20 38V26L8.05 10.75q-.7-.85-.2-1.8Q8.35 8 9.4 8h29.2q1.05 0 1.55.95t-.2 1.8Zm-4 .2L36 11H12Zm0 0Z"
    />
  </svg>
</template>
